<template>
  <div class="indexSwiper swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in slideList" :key="index" :data-bookId="item.bookId" :data-type="item.type" :data-link="item.link" :data-title="item.title"  :data-id="item.id">
        <img :src="item.image">
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from "swiper";

export default {
  // name: '首页轮播',
  data() {
    return {
      slideList: [
        // {
        //   image: require("../../assets/imgs/index/anOtherChange.png"),
        // },
        // {
        //   image: require("../../assets/imgs/index/anOtherChange.png"),
        // }
      ]
    };
  },
  created() {
    var that = this;
    var data = {
      ticket: localStorage.getItem("ticket"),
      slideType: 1
    }
    that.allApi.getCarousel(data).then(function(resource) {
      // console.log(resource.data.data)
      that.slideList = resource.data.data;
      that.$nextTick(() => {
        that.mySwiper();
      });
    });
  },
  mounted() {
    
  },
  methods: {
    mySwiper() {
      var that = this;
      var mySwiper = new Swiper(".indexSwiper", {
        loop: true, // 循环模式选项
        pagination: {
          el: '.swiper-pagination',
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        on: {
          click: function(swiper) {
            var bookId = mySwiper.clickedSlide.getAttribute('data-bookId');
            var type = mySwiper.clickedSlide.getAttribute('data-type');
            var link = mySwiper.clickedSlide.getAttribute('data-link');
            var title = mySwiper.clickedSlide.getAttribute('data-title');
            var id = mySwiper.clickedSlide.getAttribute('data-id');
            that.slideClick(bookId, type, link, title, id);
          }
        },
      });
    },
    slideClick(bookId, type, link, title, id) {
      // console.log(keyword)
      var that = this;
      if( type == 0 ){
        that.$router.push({
          path: `/bookInfo/${bookId}`
        })
      }else if( type == 1 ) {
        var data = {
          type: "slide",
          name: title,
          slideId: id
        }
        that.$router.push({
          path: "/classBookList",
          query: data
        });
      }else if( type == 2 ) {
        location.href = link;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.indexSwiper{
  width: rem(670px);
  margin: 0 auto rem(42px);

  .swiper-slide{
      width: rem(670px);
      height: rem(251px);
      border-radius: rem(16px);
      overflow: hidden;
      >img{
          display: block;
          width: 100%;
          height: 100%;
      }
  }
}

</style>
